import { useSelector } from 'react-redux';
import { LAYER_CONFIGS } from '../constants/general';
import { layerVisSelector } from '../store/selectors/layers';
import { CopyText } from './general/CopyText';

export const CopyPasteCitation = () => {
  const layerVisibility = useSelector(layerVisSelector);

  const getCitationText = () => {
    const visibleLayers = Object.keys(layerVisibility).filter(l => layerVisibility[l]);

    if (visibleLayers.length === 0) {
      return 'All data prepared and analyzed by Texas Disaster Information System';
    }
    const citation = visibleLayers.map(
      l => `${LAYER_CONFIGS[l].name} (${LAYER_CONFIGS[l].agency})`,
    );
    return `${citation.join('; ')}; All data prepared and analyzed by Texas Disaster Information System`;
  };

  const citationText = getCitationText();

  return (
    <div className="flex flex-col rounded-md bg-iceGrey px-4 py-2 text-sm" id="copy-paste-citation">
      <b className="text-base">Sources:</b>
      <div className="flex flex-row items-center justify-between gap-2">
        <span>{citationText}</span>
        <CopyText text={citationText} />
      </div>
    </div>
  );
};
